<template>
    <div>
        <div class="mb-3">
            <label class="form-label">Tarix</label>
            <el-date-picker v-model="form.date" size="large" type="date" placeholder="Seçin" style="width: 100%;"
                format="DD.MM.YYYY" />
        </div>

        <div class="mb-3">
            <label class="form-label">Saat</label>
            <el-time-picker v-model="form.time" size="large" placeholder="Seçin" style="width: 100%;" format="HH:mm"
                value-format="HH:mm" />
        </div>

        <div class="mb-3">
            <label class="form-label">Ünvan</label>
            <el-input v-model="form.address" size="large" placeholder="İclas ünvanı" />
        </div>

        <div class="mb-3">
            <label class="form-label">Qeyd</label>
            <el-input v-model="form.notes" type="textarea" size="large" placeholder="Əlavə qeyd" :rows="3" />
        </div>


        <div class="d-flex justify-content-end mt-4">
            <soft-button type="button" @click="save">Yadda saxla</soft-button>
            &nbsp;&nbsp;
            <soft-button type="button" color="secondary" @click="resetForm(); $emit('cancel')">İmtina</soft-button>
        </div>
    </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import { CreateCourtHearing, UpdateCourtHearing } from "@/project/Source/courthearings";

export default {
    components: {
        SoftButton,
    },
    props: {
        courtCaseId: {
            type: Number,
            required: true,
        },
        hearingToEdit: { type: Object, default: null }
    },
    data() {
        return {
            form: {
                date: "",
                time: "",
                address: "",
                notes: "",
            },
        };
    },

    watch: {
        hearingToEdit: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    const date = new Date(newVal.hearingDate);
                    this.form = {
                        date,
                        time: date.toTimeString().slice(0, 5),
                        address: newVal.address,
                        notes: newVal.notes,
                    };
                } else {
                    this.form = {
                        date: "",
                        time: "",
                        address: "",
                        notes: "",
                    };
                }
            }
        }
    },
    mounted() {
        if (this.hearingToEdit) {
            const date = new Date(this.hearingToEdit.hearingDate);
            this.form = {
                date,
                time: date.toTimeString().slice(0, 5),
                address: this.hearingToEdit.address,
                notes: this.hearingToEdit.notes,
            };
        }
    },
    methods: {
        resetForm() {
            this.form = {
                date: "",
                time: "",
                address: "",
                notes: "",
            };
        },
        save() {
            if (!this.form.date || !this.form.time || !this.form.address) {
                this.$message.warning("Zəhmət olmasa bütün sahələri doldurun.");
                return;
            }

            const [hours, minutes] = this.form.time.split(":").map(Number);

            const combinedDateTime = new Date(
                this.form.date.getFullYear(),
                this.form.date.getMonth(),
                this.form.date.getDate(),
                hours,
                minutes,
                0
            );

            const yyyy = combinedDateTime.getFullYear();
            const mm = String(combinedDateTime.getMonth() + 1).padStart(2, '0');
            const dd = String(combinedDateTime.getDate()).padStart(2, '0');
            const hh = String(combinedDateTime.getHours()).padStart(2, '0');
            const min = String(combinedDateTime.getMinutes()).padStart(2, '0');
            const formattedDateTime = `${yyyy}-${mm}-${dd}T${hh}:${min}:00`;

            const payload = {
                courtCaseId: this.courtCaseId,
                hearingDate: formattedDateTime,
                address: this.form.address,
                notes: this.form.notes,
                user: this.$store.state.user.id,
            };

            const request = this.hearingToEdit
                ? UpdateCourtHearing({ ...payload, id: this.hearingToEdit.id })
                : CreateCourtHearing(payload);

            request
                .then(() => {
                    this.$message.success("Uğurlu əməliyyat!");
                    this.resetForm(); 
                    this.$emit("saved");
                })
                .catch((error) => {
                    console.error("Server xətası:", error);
                    this.$message.error("Xəta baş verdi");
                });
        }


    },
};
</script>